
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.683.667a.667.667 0 01.884 0l3.75 3.429a.537.537 0 010 .808l-3.75 3.429a.667.667 0 01-.884 0 .537.537 0 010-.808L3.991 4.5.683 1.475a.537.537 0 010-.808z"}})])
          )
        }
      }
    